export default __webpack_public_path__ + "static/media/gun.86a05feb.mp3";